(function () {
    'use strict';

    // @ngInject
    function ThankYouReferralControllerCtor($scope, $injector, AnalyticsService, $modalInstance, AppStates) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'ThankYouReferralController';
        AnalyticsService.trackPageView(this, AnalyticsService.analytics_events.referral_shared_conformation_modal);

        this.AnalyticsService = AnalyticsService;
        this.modalInstance = $modalInstance;
        this.AppStates = AppStates;
    }

    Controllers.ThankYouReferralController = Class(Controllers.BaseController, {
        constructor: ThankYouReferralControllerCtor,

        cancel: function cancel() {
            this.modalInstance.dismiss();
        },
        close: function close() {
            this.AnalyticsService.trackConfirm(this, this.AnalyticsService.analytics_events.referral_shared_conformation_modal );
            this.modalInstance.close();
        },


    });
}());
